var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "forwardUpload" }, [
    _vm.saveBtn
      ? _c("div", { staticClass: "upload" }, [
          _c(
            "div",
            { staticClass: "sel" },
            [
              _c(
                "Poptip",
                {
                  attrs: {
                    trigger: "hover",
                    "word-wrap": "",
                    content: "",
                    transfer: "",
                    offset: "2",
                  },
                },
                [
                  _c("Icon", {
                    staticStyle: { marginTop: "-4px" },
                    attrs: { type: "ios-alert-outline", color: "red" },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    attrs: { slot: "content" },
                    domProps: { innerHTML: _vm._s(this.uploadTipTxt) },
                    slot: "content",
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("label", [_vm._v("附件上传项大类 : ")]),
              _vm._v(" "),
              _c(
                "Select",
                {
                  attrs: { transfer: "", clearable: "" },
                  on: {
                    "on-change": _vm.accessorySelect,
                    "on-clear": _vm.select1Clear,
                  },
                  model: {
                    value: _vm.select1Data,
                    callback: function ($$v) {
                      _vm.select1Data = $$v
                    },
                    expression: "select1Data",
                  },
                },
                _vm._l(_vm.upload1Item, function (item, index) {
                  return _c(
                    "Option",
                    { key: index, attrs: { value: item.limitval } },
                    [_vm._v(_vm._s(item.limitdesc))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sel" },
            [
              _c("label", [_vm._v("附件上传项明细 : ")]),
              _vm._v(" "),
              _c(
                "Select",
                {
                  attrs: { transfer: "", clearable: "" },
                  on: { "on-open-change": _vm.select2Open },
                  model: {
                    value: _vm.select2Data,
                    callback: function ($$v) {
                      _vm.select2Data = $$v
                    },
                    expression: "select2Data",
                  },
                },
                _vm._l(_vm.upload2Item, function (item, index) {
                  return _c(
                    "Option",
                    { key: index, attrs: { value: item.limitval } },
                    [_vm._v(_vm._s(item.limitdesc))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.uplShow
            ? _c(
                "div",
                { staticClass: "upl" },
                [
                  _c("label", [_vm._v("附件上传 : ")]),
                  _vm._v(" "),
                  _c(
                    "Upload",
                    {
                      attrs: {
                        action: "/p/cs/batchUpload",
                        name: "files",
                        "before-upload": _vm.beforeUpload,
                        accept: _vm.acceptFile,
                        "on-success": _vm.onSuccess,
                        "on-error": _vm.onError,
                        "on-remove": _vm.onRemove,
                        data: _vm.uplData,
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "uplFile" },
                        [
                          _c("Icon", { attrs: { type: "md-cloud-upload" } }),
                          _vm._v("上传附件\n        "),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pageNation" },
      [
        _c("Page", {
          attrs: {
            total: _vm.page.total,
            "show-sizer": "",
            "page-size-opts": _vm.page.pageSizeOpts,
            current: _vm.page.current,
            "page-size": _vm.page.pageSize,
          },
          on: {
            "on-change": _vm.pageChange,
            "on-page-size-change": _vm.pageSizeChange,
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "button" }, [
          _vm.saveBtn
            ? _c(
                "span",
                {
                  on: {
                    click: function ($event) {
                      return _vm.save({
                        detail: { type: "saveWithWorwardUpload" },
                      })
                    },
                  },
                },
                [_vm._v("【保存】")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.deleteBtn
            ? _c("span", { on: { click: _vm.delItem } }, [
                _vm._v("【删除明细】"),
              ])
            : _vm._e(),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table" },
      [
        _c("Table", {
          attrs: {
            columns: _vm.tableConfig.columns,
            data: _vm.tableConfig.data,
          },
          on: { "on-selection-change": _vm.onSelectChange },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }